// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router";
// import LoadingPage from "../Components/layouts/loading";
// import performRequest from "../api/request";

// const WebinarFallbackPage = () => {
//   const [loading, setLoading] = useState(true);
//   const { uuidtoken } = useParams();

//   useEffect(() => {
//     if (!uuidtoken) return;

//     performRequest("GET", `/webinar/webinar-uuid/${uuidtoken}`)
//       .then((res) => {
//         if (res?.status === 200 && res?.data?.redirectUrl?.startsWith("http")) {
//           window.location.replace(res.data.redirectUrl);
//         } else {
//           console.error("Invalid redirect URL");
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         console.error("Error redirecting:", err);
//         setLoading(false);
//       });
//   }, [uuidtoken]);

//   if (loading) return <LoadingPage />;
//   return <div>Invalid or expired link</div>;
// };

// export default WebinarFallbackPage;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import performRequest from "../api/request";
import Footer from "../Components/Footer/footer";

const WebinarFallbackPage = () => {
  const { uuidtoken } = useParams();
  console.log("UUID Token:", uuidtoken);
  // const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Verifying your webinar link...");
  const [copied, setCopied] = useState(false);
  const [countdown, setCountdown] = useState(20);

  const [data, setData] = useState();

  useEffect(() => {
    if (!countdown) {
      if (data?.sessionUrl) {
        window.location.href = data?.sessionUrl; // redirect
      }
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, data]);

  const progress = ((20 - countdown) / 20) * 100;

  useEffect(() => {
    if (!uuidtoken) {
      setMessage("Invalid link. Please check your webinar link.");
      return;
    }

    const fetchRedirect = async () => {
      try {
        const res = await performRequest(
          "GET",
          `/webinar/webinar-uuid/${uuidtoken}`
        );

        if (res?.status === 200) {
          setData(res?.data?.data);
        } else {
          console.error("Invalid redirect URL:", res?.data);
          setMessage("This webinar link is invalid or expired.");
        }
      } catch (error) {
        console.error("Error redirecting:", error);
        setMessage("Something went wrong while verifying your link.");
      }
    };

    fetchRedirect();
  }, [uuidtoken]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(data?.sessionUrl || "");
      setCopied(true);

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xxl">
            <div className="page-header d-print-none">
              <div className="row align-items-center">
                <div className="col-md-8">
                  {/* Page Title */}
                  <h2 className="page-title mb-1">🌿 Hydroponic Webinar</h2>
                  <h5 className="text-muted mb-4">
                    Please wait while we redirect you to the webinar session.
                  </h5>
                  <div className="">
                    <p className="text-muted text-center mb-2">
                      Redirecting automatically in <strong>{countdown}s</strong>
                      ...
                    </p>
                    <div
                      style={{
                        height: "8px",
                        width: "100%",
                        background: "#e9ecef",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: `${progress}%`,
                          background: "#007bff",
                          transition: "width 1s linear",
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Main Info */}
                  <p>
                    We’ve sent you an email with all the details at{" "}
                    <strong>{data?.email || "your registered email"}</strong>.
                  </p>
                  <p>
                    You can join the webinar directly from your email, or copy
                    the link below and open it in your browser if it is not
                    automatically redirected. Please wait for timer to finish.
                  </p>

                  {/* Link Card */}
                  {/* Copy Link Button */}
                  <div className="text-center mb-4">
                    <span> 👉 Click here </span>
                    <button
                      onClick={handleCopy}
                      className="btn btn-primary"
                      style={{ borderRadius: "6px", padding: "8px 20px" }}
                    >
                      {copied ? "✅ Link Copied!" : "📋 Copy Link"}
                    </button>
                  </div>
                  <div className="card bg-light p-3 mb-3">
                    <p
                      className="mb-0 text-break"
                      style={{
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        fontWeight: "500",
                      }}
                    >
                      {data?.sessionUrl || "Loading..."}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default WebinarFallbackPage;
